import { IconButton, LinkIcon, Tooltip } from '@methanesat/ui-components';
import { useState } from 'react';
import { useTranslate } from '../../../../hooks';

/** Component that copies the current url to the user's clipboard  */
export const ShareableLink = () => {
    const t = useTranslate();
    const [isCopied, setIsCopied] = useState(false);
    const tooltipText = isCopied
        ? t('emissionsMapPage.mapModals.linksToFeatures.buttonFeedback')
        : t('emissionsMapPage.mapModals.linksToFeatures.tooltipTitle');

    const copyToClipboard = () => {
        navigator.clipboard.writeText(window.location.href);
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    };

    return (
        <Tooltip title={tooltipText} enterTouchDelay={0} leaveDelay={500}>
            <IconButton data-testid="share-drawer-button" onClick={copyToClipboard} color="primary">
                <LinkIcon sx={{ transform: 'rotate(-0.125turn)' }} />
            </IconButton>
        </Tooltip>
    );
};
